export default "__VITE_ASSET__f249c665__"